import { useMemo } from 'react'

import { EtaDistanceResult } from '@/feature/eta'

import { formatTimeStamp } from '../../utils/Eta.utils'
import styles from './Eta.module.css'

export const LocationToContent = ({ etaResult }: { etaResult: EtaDistanceResult }) => (
  <div className={styles.locationToContent}>
    <div className={styles.locationToContentColumn}>
      <div className={styles.locationToContentColumnTitle}>ETA</div>
      <div className={styles.locationToContentColumnContent}>
        {useMemo(() => formatTimeStamp(etaResult?.duration?.value), [etaResult?.duration?.value])}
      </div>
    </div>
    <div className={styles.locationToContentColumn}>
      <div className={styles.locationToContentColumnTitle}>Distance</div>
      <div className={styles.locationToContentColumnContent}>{etaResult?.distance}</div>
    </div>
    <div className={styles.locationToContentColumn}>
      <div className={styles.locationToContentColumnTitle}>Duration</div>
      <div className={styles.locationToContentColumnContent}>{etaResult?.duration?.text}</div>
    </div>
  </div>
)
